import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CompanyPolicyComponent } from './company-policy.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';

@NgModule({
  providers: [LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/company-policy', component: CompanyPolicyComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'COMPANY_POLICY_URL'}},
      { path: ':language/politica-de-empresa', component: CompanyPolicyComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'COMPANY_POLICY_URL'}},
      { path: ':language/company-policy', component: CompanyPolicyComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'COMPANY_POLICY_URL'}},
      { path: ':language/company-policy', component: CompanyPolicyComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'COMPANY_POLICY_URL'}},
      { path: ':language/company-policy', component: CompanyPolicyComponent, canActivate: [LanguageInterceptor], data: {localeTag: 'COMPANY_POLICY_URL'}}
    ])
  ]
})
export class CompanyPolicyRoutingModule {
}
